<template>
    <div class="container mt-5">
      <b-card :title="$t('Movements_managment')">
        <!-- Form Section -->
        <div class="card p-4 mb-4 shadow-lg border-0">
          <form @submit.prevent="saveMovement" class="row g-3 align-items-center">
            <div class="col-12 col-md-4">
              <input
                v-model="formData.code"
                class="form-control shadow-sm"
                :placeholder="$t('input_code')"
                required
              />
            </div>
            <div class="col-12 col-md-4">
              <input
                v-model="formData.value"
                class="form-control shadow-sm"
                :placeholder="$t('input_value')"
                required
              />
            </div>
            <div class="col-12 col-md-4">
              <button type="submit" class="btn btn-success btn-lg w-100">
                {{ formData.id ? $t('update') : $t('add') }}
              </button>
            </div>
          </form>
        </div>
      
        <!-- Table Section -->
        <div class="card shadow-lg border-0">
          <b-table :items="items" :fields="fields" striped bordered hover :row-class="getRowClass">
            <!-- Custom Actions Column -->
            <template #cell(actions)="data">
              <b-button
                variant="primary"
                size="sm"
                class="me-2"
                @click="editMovement(data.item)"
              >
                <i class="fas fa-edit"></i> Edit
              </b-button>
              <b-button
                variant="danger"
                size="sm"
                @click="deleteMovement(data.item.id)"
              >
                <i class="fas fa-trash"></i> Delete
              </b-button>
            </template>
            
            <!-- Custom source column rendering -->
            <template #cell(source)="data">
              <!-- Display the source.value -->
              {{ data.item.source ? data.item.source.value : 'N/A' }}
            </template>
            
            <!-- Custom 'Total Prix / Total en Kg' column -->
            <template #cell(totalRatio)="data">
              <!-- Calculate the ratio (prixTot / poidTot), check for zero to avoid division by zero -->
              {{ data.item.prixTot && data.item.poidTot ? (data.item.prixTot / data.item.poidTot).toFixed(2) : 'N/A' }}
            </template>
            
            <!-- Footer row to display the total sum of 'Nombre' -->
            <template #footer>
            <b-tr>
                <b-td colspan="4">Total</b-td>
                <b-td>{{ totalNombre }}</b-td>
                <b-td></b-td> <!-- Empty cell for Total Prix -->
                <b-td></b-td> <!-- Empty cell for Source -->
                <b-td></b-td> <!-- Empty cell for Remarque -->
                <b-td></b-td> <!-- Empty cell for Actions -->
            </b-tr>
            </template>
            
          </b-table>
          
          

            



        </div>
      </b-card>
    </div>
  </template>
  
  <script>
  import { MovementService } from '../api';
  import { Message } from "../libjs/alertService"; // Adjust the path
  
  export default {
    data() {
      return {
        Movements: [],
        formData: {
          id: null,
          code: "",
          value: "",
          source: { value: "" }, // Ensure source is structured
        },
        currentLocale: "en",
        fields: [
          //{ key: 'id', label: 'ID', sortable: true },
          //{ key: 'e_s', label: 'E_S', sortable: false },
          { key: 'date', label: 'Date', sortable: true },
          { key: 'nombre', label: 'Nombre', sortable: true },
          { key: 'poidTot', label: 'Total en Kg', sortable: true },
          { key: 'prixTot', label: 'Total Prix', sortable: true },
          { key: 'source', label: 'Source', sortable: true },
          { key: 'remarque', label: 'Remarque', sortable: true },
          { key: 'totalRatio', label: 'Prix per Kg', sortable: false },
          { key: 'actions', label: 'Actions' }
        ],
        items: [],
      };
    },
    computed: {
      totalNombre() {
        // Calculate the total sum of the 'nombre' column
        //return this.items.reduce((total, item) => total + (item.nombre || 0), 0);
        return this.items.reduce((total, item) => {
            return total + parseInt(item.nombre);
        }, 0);
      },
    },
    methods: {
     async fetchMovements() {
        try {
            const response = await MovementService.listMovement();
            this.Movements = response;
            this.items = response;
            console.log('Items after fetching:', JSON.stringify(this.items)); // This should now show the correct data
        } catch (error) {
            console.error('Error fetching data:', error);
        }
      },
      async saveMovement() {
        try {
          if (this.formData.id) {
            await MovementService.updateMovementIncoming(this.formData.id, this.formData);
            Message('success', this.$t('message.update_success'));
          } else {
            await MovementService.createMovementIncoming(this.formData);
            Message('success', this.$t('message.add_success'));
          }
          this.resetForm();
          this.fetchMovements();
        } catch (error) {
          Message('danger', this.$t('message.operation_failed'));
        }
      },
      async deleteMovement(id) {
        try {
          await MovementService.deleteMovement(id);
          this.fetchMovements();
          Message('success', this.$t('message.delete_success'));
        } catch (error) {
          Message('danger', this.$t('message.delete_failed'));
        }
      },
      editMovement(Movement) {
        this.formData = { ...Movement };
      },
      resetForm() {
        this.formData = {
          id: null,
          code: "",
          value: "",
          source: { value: "" }, // reset the source value
        };
      },
      changeLanguage() {
        this.$i18n.locale = this.currentLocale;
        document.documentElement.lang = this.currentLocale;
        document.documentElement.dir = this.currentLocale === "ar" ? "rtl" : "ltr";
      },
      // Method to dynamically add class based on the value of 'e_s'
      getRowClass(item) {
        return item.e_s === 'E' ? 'row-e' : 'row-s';
      }
    },
    mounted() {
      this.fetchMovements();
      //this.items = this.Movements;
      //console.log(JSON.stringify(this.items));
      this.$nextTick(() => {
    console.log('Items after nextTick:', this.items); // Ensure DOM is updated
    });
    },
  };
  </script>
  
  <style scoped>
  /* Add custom styles for the row based on E_S value */
  .row-e {
    background-color: #f0f8ff; /* Light blue for 'E' */
  }
  
  .row-s {
    background-color: #fff0f5; /* Light pink for 'S' */
  }
  </style>
  